import React, { FC } from 'react';
import './thumbnail.scss';
import { observer } from 'mobx-react';

interface IProps {
  title: string;
  thumbnailSrc: string;
  thumbnailNumber: number;
}

const Thumbnail: FC<IProps> = ({ title, thumbnailSrc, thumbnailNumber }): JSX.Element => {
  return (
    <>
      {title && <span className="thumbnail__title">{title}</span>}
      <div className="thumbnail__content">
        <span className="thumbnail__content__number">{thumbnailNumber}</span>
        <div className="thumbnail__content__image">
          <img src={thumbnailSrc} alt=""/>
        </div>
      </div>
    </>
  );
};

export default observer(Thumbnail);